import { SVGProps } from 'react';

const SvgAddSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={8} cy={8} r={7} fill="#FE8C75" />
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M4.5 8a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5Z"
      clipRule="evenodd"
    />
    <path
      fill="#081930"
      fillRule="evenodd"
      d="M8 4.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V5a.5.5 0 0 1 .5-.5Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgAddSmall;
